import styled from 'styled-components';

export const CartPreviewEntryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${Styles.color.black};
  margin-block-end: 0.5rem;
`;
